import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import MainView from '../views/MainView'

const original = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return original.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: LoginView
  }, {
    path: '/main',
    name: 'MainView',
    component: MainView,
    redirect: '/main/goodsview',
    children: [
      //订单管理中心
      { path: 'moneylog', name: 'MoneyLog', component: () => import('../views/MoneyLogView') },
      { path: 'orderview', name: 'OrderView', component: () => import('../views/OrderView') },
      { path: 'ordertestview', name: 'OrderTestView', component: () => import('../views/OrderTestView') },
      { path: 'orderbatview', name: 'OrderBatView', component: () => import('../views/OrderBatView') },
      { path: 'ordermanagerview', name: 'OrderManagerView', component: () => import('../views/OrderManagerView') },
      { path: 'ordercommissionview', name: 'OrderCommissionView', component: () => import('../views/OrderCommissionView') },
      { path: 'ordernotirecordview', name: 'OrderNotiRecordView', component: () => import('../views/OrderNotiRecordView') },
      { path: 'ordernotirecordyunhaokaview', name: 'OrderNotiRecordYunhaokaView', component: () => import('../views/OrderNotiRecordYunhaokaView') },

      //代理管理中心
      { path: 'agentview', name: 'AgentView', component: () => import('../views/AgentView') },
      { path: 'agentdetailview', name: 'AgentDetailView', component: () => import('../views/AgentDetailView') },
      { path: 'agentbinddouyin', name: 'AgentBindDouyin', component: () => import('../views/AgentBindDouyin') },

      //产品管理中心
      { path: 'goodsview', name: 'GoodsView', component: () => import('../views/GoodsView') },
      { path: 'goodsoutview', name: 'GoodsOutView', component: () => import('../views/GoodsOutView') },
      { path: 'goodstypeview', name: 'GoodsTypeView', component: () => import('../views/GoodsTypeView') },

      { path: 'goodsliveview', name: 'GoodsLiveView', component: () => import('../views/GoodsLiveView') },
      { path: 'goodsliveksview', name: 'GoodsLiveKSView', component: () => import('../views/GoodsLiveKSView') },

      //其它
      { path: 'otheractview', name: 'OtherActView', component: () => import('../views/OtherActView') },
      { path: 'othercreditcardview', name: 'OtherCreditCardView', component: () => import('../views/OtherCreditCardView') },
      { path: 'othercustomview', name: 'OtherCustomView', component: () => import('../views/OtherCustomView') },

      { path: 'userproxyview', name: 'UserProxyView', component: () => import('../views/UserProxyView') },
      { path: 'userproxyorderview', name: 'UserProxyOrderView', component: () => import('../views/UserProxyOrderView') },
      { path: 'userproxyorderbatview', name: 'UserProxyOrderBatView', component: () => import('../views/UserProxyOrderBatView') },
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/Test'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
